import { render } from "./DatabaseMan.vue?vue&type=template&id=35219095&scoped=true"
import script from "./DatabaseMan.vue?vue&type=script&lang=js"
export * from "./DatabaseMan.vue?vue&type=script&lang=js"

import "./DatabaseMan.vue?vue&type=style&index=0&id=35219095&scoped=true&lang=css"
import "./DatabaseMan.vue?vue&type=style&index=1&id=35219095&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35219095"]])

export default __exports__